import { Stack } from '@mui/material'
import React, { useState, useEffect }  from 'react'
import { fetchAPI } from '@/utility/NetworkUtils'
import Loading from '@/shared/Loading'
import { renderSelectFieldFilterable } from '@/shared/FormUtils'
const EventAddressForm = (props) => {
  const [addresses, setAddresses] = useState([])
  const { formikProps, event } = props
  const [ loading, setLoading ] = useState(true)

  useEffect(() => {
    fetchAddresses()
  }, [])

  const fetchAddresses = () => {
    setLoading(true)
    fetchAPI(`/webapi/shipping_addresses`).then((response) => {
      setLoading(false)
      setAddresses((response && response.shipping_addresses) || [])
    })
  }

  // Addresses already attached to the event may be archived or private, which
  // means they are not returned by the index above. Fall back to the copies
  // that came back with the event so they still render (and can be removed).
  const findAddress = (address_id) => {
    return addresses.find(x => x.id === address_id) ||
      ((event && event.shipping_addresses) || []).find(x => x.id === address_id)
  }
  if(loading) {
    return <Loading />
  }

  const renderAddressOption = (props, data) =>{
    return (
      <div {...props} className={props.noSelect ? "" : "hover:bg-[#e6e6e6]"} style={{ alignItems: 'center', padding: '8px 12px' }}>
        <div className="block">
          <b>{data.label}</b>
        </div>
        <div  className="block">
          {data.address?.address_line_1} 
          <br/>
          {data.address?.address_line_2}
        </div>
        <div className="block">
          {[data.address?.city, data.address?.state_province, data.address?.postal_code].filter(x=>x).join(", ")}
        </div>
        <div className="block">
          {data.address?.country}
        </div>
      </div>
    )
  }

  const generateAddressOptions = () => {
    const filteredAddresses = addresses.filter(x=>
      !formikProps.values.shipping_address_ids.includes(x.id)
    ).map(address =>
      {return {label: address.venue_name, value: address.id, address: address}}
    );
    return filteredAddresses
  }

  const renderShippingAddressList = () => {
    return formikProps.values.shipping_address_ids.map((address_id, index) => {
      const address = findAddress(address_id)
      return (
        <div className="flex border-b-1 border-[#e6e6e6]" key={`shipping_address_${address_id}`} style={{borderBottom: "1px solid #e6e6e6"}}>
          <div className="w-full">
            {renderAddressOption({noSelect: true}, {label: address ? address.venue_name : "Unavailable address", address: address || {}})}
          </div>
          <div className="flex align-middle p-8 items-center">
            <a href="javascript:void(0)" className="text-blue-600" onClick={(e) => {
              e.preventDefault()
              formikProps.setFieldValue("shipping_address_ids", 
                formikProps.values.shipping_address_ids.filter(x => x !== address_id)
              )
            }}>
              Remove
            </a>
          </div>
        </div>
      )
    })
  }

  return (
    <Stack spacing={2} direction="column">
      <div>
        Add shipping addresses by selecting them from the dropdown. To create new or edit an existing shipping address, please go to the <a href="events/shipping_addresses">Address Book</a>.
      </div>
      {renderSelectFieldFilterable(
        "Shipping Location",
        "select_shipping_address",
        generateAddressOptions(formikProps),
        {
          fieldProperties: {
            renderOption: renderAddressOption,
            getOptionLabel: (option) => {  return option.label}
          },
          onChange: (e) => {
            formikProps.setFieldValue("shipping_address_ids", 
              [...formikProps.values.shipping_address_ids, e].filter((x,i,a) => a.indexOf(x) === i)
            )
            formikProps.setFieldValue("select_shipping_address", "")
          }
        }
      )}

      {renderShippingAddressList()}
    </Stack>
  )
}

export default EventAddressForm